module.exports = __webpack_public_path__ + "static/media/vue.168c2754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Languages/img/vue.svg
// module id = 119
// module chunks = 0